exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-storyblok-entry-full-slug-js": () => import("./../../../src/pages/{storyblokEntry.full_slug}.js" /* webpackChunkName: "component---src-pages-storyblok-entry-full-slug-js" */)
}

